import React, { useState, useContext } from "react"
import MelodySelect from "../../../../components/modal/melodySelect"
import { ReactComponent as SelectIcon } from "../../../../assets/images/select-icon.svg"
import { MelodiesContext } from "../../../../context/MelodiesContext"

const MAX_REPEAT_COUNT = 255
const MAX_REPEAT_INTERVAL = 65535
const MAX_TEMPLATE_DELAY = 65535

/**
 * Звон программы (шаблона).
 */
const TemplateSlot = ({
    title,
    slot,
    changeMelody,
    changeRepeatCount,
    changeRepeatInterval,
    changeTemplateDelay
}) => {
    const melodiesContext = useContext(MelodiesContext)

    const [isMelodyModalOpen, setIsMelodyModalOpen] = useState(false)

    const melodyTitle = melodiesContext.getTitle(slot.melody)

    /**
     * Проверит допустимое количество повторов.
     */
    const validateRepeatCount = (value) => {
        let newValue = value

        if (value <= 0) {
            newValue = 0
        } else if (value >= MAX_REPEAT_COUNT) {
            newValue = MAX_REPEAT_COUNT
        }

        changeRepeatCount(parseInt(newValue))
    }

    /**
     * Проверит значение задержки между повторами.
     */
    const validateRepeatInterval = (value) => {
        let newValue = value

        if (value <= 0) {
            newValue = 0
        } else if (value >= MAX_REPEAT_INTERVAL) {
            newValue = MAX_REPEAT_INTERVAL
        }

        changeRepeatInterval(parseInt(newValue))
    }

    /**
     * Првоерит значение задержки между звонами.
     */
    const validateTemplateDelay = (value) => {
        let newValue = value

        if (value <= 0) {
            newValue = 0
        } else if (value >= MAX_TEMPLATE_DELAY) {
            newValue = MAX_TEMPLATE_DELAY
        }

        changeTemplateDelay(parseInt(newValue))
    }

    return (
        <div className="template-slot">
            <div className="template-slot__option">
                <div className="template-slot__title">
                    {title}
                </div>

                <div className="chimes-options">
                    <div
                        className="input-link chimes-options"
                        onClick={() => setIsMelodyModalOpen(true, 1)}
                    >
                        <div className="input-container _no-mr">
                            <div className="input-area">
                                <input
                                    name="melody"
                                    type="text"
                                    readOnly
                                    value={melodyTitle}
                                />

                                <SelectIcon className="select-icon _abs" />

                                <MelodySelect
                                    isOpen={isMelodyModalOpen}
                                    selected={slot.melody}
                                    items={melodiesContext.melodies}
                                    modalIndex={1}
                                    setModal={setIsMelodyModalOpen}
                                    setMelody={changeMelody}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div>
                <div className="general-title _mr">
                    Количество повторов
                </div>
                <div className="general-item">
                    <div className="force-count-area">
                        <div
                            onClick={() => validateRepeatCount(slot.repeatCount - 1)}
                            className="dec"
                        >
                            <span>-</span>
                        </div>

                        <input
                            onChange={(e) => validateRepeatCount(e.target.value)}
                            name="repeatCount"
                            value={slot.repeatCount}
                            className="count"
                        />

                        <div
                            onClick={() => validateRepeatCount(slot.repeatCount + 1)}
                            className="inc"
                        >
                            <span>+</span>
                        </div>
                    </div>
                </div>
            </div>

            <div>
                <div className="general-title _mr">
                    Задержка между повторами, сек:
                </div>
                <div className="general-item">
                    <div className="force-count-area">
                        <div
                            onClick={() => validateRepeatInterval(slot.repeatInterval - 1)}
                            className="dec"
                        >
                            <span>-</span>
                        </div>

                        <input
                            onChange={(e) => validateRepeatInterval(e.target.value)}
                            name="repeatInterval"
                            value={slot.repeatInterval}
                            className="count"
                        />

                        <div
                            onClick={() => validateRepeatInterval(slot.repeatInterval + 1)}
                            className="inc"
                        >
                            <span>+</span>
                        </div>
                    </div>
                </div>
            </div>

            {slot.templateDelay !== undefined
                && <div>
                    <div className="general-title _mr">
                        Задержка между звонами, сек
                    </div>
                    <div className="general-item">
                        <div className="force-count-area">
                            <div
                                onClick={() => validateTemplateDelay(slot.templateDelay - 1)}
                                className="dec"
                            >
                                <span>-</span>
                            </div>

                            <input
                                onChange={(e) => validateTemplateDelay(e.target.value)}
                                name="templateDelay"
                                value={slot.templateDelay}
                                className="count"
                            />

                            <div
                                onClick={() => validateTemplateDelay(slot.templateDelay + 1)}
                                className="inc"
                            >
                                <span>+</span>
                            </div>
                        </div>
                    </div>
                </div>
            }

        </div>
    )
}

export default TemplateSlot